export const DASHBOARD_READY = 'DASHBOARD_READY';

export const UPDATED_DASHBOARD = 'UPDATED_DASHBOARD';

export const ADD_WIDGET = 'ADD_WIDGET';

export const UPDATE_WIDGET = 'UPDATE_WIDGET';

export const UPDATE_BENCHMARK = 'UPDATE_BENCHMARK';

export const UPDATE_BENCHMARK_VISIBILITY = 'UPDATE_BENCHMARK_VISIBILITY';

export const DELETE_WIDGET = 'DELETE_WIDGET';

export const RESET_CREATE_DATA = 'RESET_CREATE_DATA';
